import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  option: {
    title: '',
    description: '',
    keywords: ''
  },
  loginUser: JSON.parse(localStorage.getItem('loginUser'))
}
const mutations = {
  option (state, option) {
    state.option = option
  },
  loginUser (state, loginUser) {
    if(loginUser) {
      localStorage.setItem("loginUser", JSON.stringify(loginUser))
      state.loginUser = loginUser
    } else {
      localStorage.removeItem('loginUser')
      state.loginUser = null
    }
  }
}
const getters = {
  option (state) {
    return state.option
  },
  loginUser (state) {
    return state.loginUser
  }
}
export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js